import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AdoptionMiddleware from './../modules/adoption/middleware'
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown'
import SelectSegments from './../components/Select/Books/SelectSegments'

const mapStateToProps = ({ books, education, adoption }) => ({
  subjects: education.subjects,
  segments: education.segments,
  gradeId: adoption.filterGradeId
})

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({
    addNewSchoolAdoption: (newItem) => AdoptionMiddleware.addNewAdoptionItem(newItem),
    toggleDialog: () => AdoptionMiddleware.dialogAdoptionToggleView(),
    changeItemDialog: (newItem) => AdoptionMiddleware.dialogAdoptionChangeItem(newItem)
  }, dispatch)
)

class NewSchoolAdoptionContainer extends Component {
  state = {
    subjectID: {value: null, isPristine: true},
    isOpen: false
  }
  initialState = {
    subjectID: {value: null, isPristine: true},
    isOpen: false
  }
  static mapTypeToState = {
    subjects: 'subjectID'
  }
  changeState = (type, currentId) => {
    this.setState({[NewSchoolAdoptionContainer.mapTypeToState[type]]: {
      isPristine: false,
      value: currentId
    }})
  }
  handleShow = () => {
    this.setState({isOpen: true})
  }
  handleHide = () => {
    this.setState({isOpen: false})
  }
  addNewSchoolAdoption = () => {
    const { subjectID } = this.state
    this.props.addNewSchoolAdoption({
      subjectId: subjectID.value,
      bookId: this.props.bookId,
      gradeId: this.props.gradeId
    })
    this.dropdown.hide()
    this.resetForm()
  }
  resetForm = () => {
    this.selectSubject.resetValue()
    this.setState({...this.initialState})
  }
  isInvalidForm = () => {
    const { subjectID } = this.state
    return subjectID.isPristine
  }
  componentDidMount () {
    this.elementContentID = document.getElementById(`dropdown__content--${this.props.bookId}`)
  }
  render () {
    const { subjects } = this.props
    const mapSelectOptions = (type) => (type.items.map((item) => ({label: item.name, value: item.id})))
    return (
      <Dropdown className='dropdown--with-caret' id={`dropdown__content--${this.props.bookId}`} onShow={this.handleShow} onHide={this.handleHide} ref={(element) => { this.dropdown = element }}>
        <DropdownTrigger>
          <button className='dropdown__trigger__button'><i className='fa fa-plus' /></button>
        </DropdownTrigger>
        <DropdownContent>
          <div>
            <div className='dropdown__content__header'>Adicionar à Livro na:</div>
            <div className='dropdown__content__body'>
              <div className='dropdown__content__body__select-item'>
                <span className='select-filter__label'>Disciplina: </span>
                {subjects.items.length > 0 && (
                  <SelectSegments
                    options={mapSelectOptions(subjects)}
                    isLoading={subjects.isFetching}
                    placeholder='Selecione a disciplina'
                    type='subjects'
                    changeFilter={this.changeState}
                    multi={false}
                    clearable={false}
                    ref={(element) => { this.selectSubject = element }}
                  />
                )
                }
              </div>
            </div>
            <div className='dropdown__content__footer'>
              <button className='button is-success' disabled={this.isInvalidForm()} onClick={this.addNewSchoolAdoption}>Adicionar</button>
            </div>
          </div>
        </DropdownContent>
      </Dropdown>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewSchoolAdoptionContainer)



// WEBPACK FOOTER //
// ./src/containers/NewSchoolAdoptionContainer.js